export default __webpack_public_path__ + "static/media/heat-1.7f459596.png";